import { getPagePathByKey } from '@repo/permissions';

const STABLE_KEY = /^[a-z][a-z0-9-]{0,119}$/;
const ID = /^[a-f0-9]{24}$/i;
export const REPORT_STUDIO_INTENT_VERSION = 1;

export function resolveReportStudioSourcePath(definition) {
    const sourcePageKey = String(definition?.launchContext?.sourcePageKey || '').trim();
    if (!sourcePageKey) return { path: '', available: false, sourcePageKey: '' };
    const path = getPagePathByKey(sourcePageKey) || '';
    return { path, available: Boolean(path), sourcePageKey };
}

export function buildReportStudioNavigationState({ reportKey, profileId, profileVersion, scopeMode } = {}) {
    const normalizedReportKey = String(reportKey || '').trim();
    const normalizedProfileId = String(profileId || '').trim();
    if (!STABLE_KEY.test(normalizedReportKey) || !ID.test(normalizedProfileId)) return null;
    const intentId = globalThis.crypto?.randomUUID?.();
    if (!intentId) return null;
    return {
        reportStudioIntent: {
            version: REPORT_STUDIO_INTENT_VERSION,
            intentId,
            reportKey: normalizedReportKey,
            profileId: normalizedProfileId,
            profileVersion: Number.isInteger(profileVersion) && profileVersion > 0 ? profileVersion : undefined,
            scopeMode: ['filtered', 'selected', 'single', 'tenant'].includes(scopeMode) ? scopeMode : undefined,
        },
    };
}

export function readReportStudioNavigationIntent(locationState) {
    const raw = locationState?.reportStudioIntent;
    if (!raw || raw.version !== REPORT_STUDIO_INTENT_VERSION
        || typeof raw.intentId !== 'string' || raw.intentId.length < 8 || raw.intentId.length > 120
        || !STABLE_KEY.test(String(raw.reportKey || ''))
        || !ID.test(String(raw.profileId || ''))) return null;
    if (raw.profileVersion !== undefined && (!Number.isInteger(raw.profileVersion) || raw.profileVersion < 1)) return null;
    if (raw.scopeMode !== undefined && !['filtered', 'selected', 'single', 'tenant'].includes(raw.scopeMode)) return null;
    return Object.freeze({
        version: REPORT_STUDIO_INTENT_VERSION,
        intentId: raw.intentId,
        reportKey: raw.reportKey,
        profileId: raw.profileId,
        ...(raw.profileVersion ? { profileVersion: raw.profileVersion } : {}),
        ...(raw.scopeMode ? { scopeMode: raw.scopeMode } : {}),
    });
}

export function withoutReportStudioIntent(locationState) {
    if (!locationState || typeof locationState !== 'object') return null;
    const { reportStudioIntent: _ignored, ...rest } = locationState;
    return Object.keys(rest).length ? rest : null;
}
